//import { Component, OnInit } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, NgZone} from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs/Rx';
declare var $;
@Component({
  selector: 'app-dashboard-essentiel',
  templateUrl: './dashboard-essentiel.component.html',
  styleUrls: ['./dashboard-essentiel.component.css']
})
export class DashboardEssentielComponent implements OnInit {

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    isWeek: true,
    dateInterval: [
      new Date(moment().subtract(6, 'days').format('YYYY-MM-DD')),
      new Date(moment().format('YYYY-MM-DD'))
    ]
  };
  staticFilter :any;
  routeBase: string;
  dtCurrentpage: any;
  dtCurrentLen: any;
  dtIntiFlag: any;
  clients: any[];
  schools: any[];
  buses: any[];
  TauxUtilisationGeneral: any;
  TotalsubScription:any;
  dtOptions: any = {};
  passengers: any[];
  periodMaxCnx:any[];
  periodConnection: any[];
  categories: { days: string[], buses: string[] };

  user: any;

  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  i = 0;
  chartData: {
    categories: any[],
    series: any[]
  };
  chartData2: {
    categories: any[],
    series: any[]
  };
  Highcharts: typeof Highcharts = Highcharts;
  chart1Options: {};
  chart2Options: {};


  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) { 
    this.routeBase = 'passenger';
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.user = this.authService.getUser();
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      this.filter.clientId = this.user.id;
      this.staticFilter.clientId = this.user.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.filter.clientId = this.user.School.Client.id;
      this.filter.schoolId = this.user.School.id;
      this.staticFilter.clientId = this.user.School.Client.id;
      this.staticFilter.schoolId = this.user.School.id;
      this.onFilter();
    }

    this.chartData = {
      categories: [],
      series: []
    };
    this.chartData2 = {
      categories: [],
      series: []
    };
    this.periodMaxCnx = [[], []];
    this.routeBase = 'passenger';
    this.dtIntiFlag = false;
    this.route.params.subscribe(params => {
      this.dtCurrentpage = params['PgNo'];
      this.dtCurrentLen = params['PgLen'];
    });

    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      this.clients = clients;
      const array1 = [{ id: '', text: 'Choisir un client' }];
      const array2 = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name };
      });
      this.clientsData = array1.concat(array2);
    });

  }

  ngOnInit() {
    
    this.routeBase = 'passenger';
    // Event lors de la fin d'init du dt
    $('table').on('init.dt', (event) => this.initPaginationTable());

    const columns = [
      { data: 'lastFirstname' },
      { data: 'busName' },
      { data: 'phone' },
      { data: 'count' },
      { data: 'activationKey' },
      { data: 'actions' },
    ];
    
    this.dtOptions = {
      searching: false,
      pageLength: Number(this.dtCurrentLen),
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/passengerSubscription',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengers = resp.data;
          let dta = [];
          this.passengers.forEach((passenger, index) => {
            dta.push({
              id: passenger.id,
              lastFirstname: passenger.lastname + '-' + passenger.firstnames,
              busName: passenger.Bus ? passenger.Bus.name : '',
              phone: passenger.phone,
              count: passenger.count,
              activationKey: passenger.activationKey,
              actions: `
              <button class="btn btnAction btnNavigate" data-url="/${this.routeBase}/view/${passenger.id}" target="_blank">
                <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
              </button>
                `
            });
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passenger_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url') + '/0/5');
    });
    $('table').on('draw.dt', (event) => this.onDtDrawChange());
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.staticFilter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.filter.schoolId = schools.length ? schools[0].id : '';
      this.schoolsData = schools.map((school, index) => {
        return {
          id: school.id,
          text: school.name,
          selected: school.id == this.filter.schoolId ? true : false
        };
      });
      this.onFilter();
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
  }

  onDtDrawChange() {
    this.updatePaginationInfo();
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  initPaginationTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const totalPg = pgsInfo.pages;
      let pgNo  = 0;

      if (this.dtCurrentpage === 'last' ) {
        pgNo = totalPg - 1;
      } else {
        pgNo = Number(this.dtCurrentpage);
      }
      // dtInstance.page.len(Number(this.dtCurrentLen));
      dtInstance.page(pgNo);
      dtInstance.draw(false);
      this.dtIntiFlag = true;
   });
  }

  updatePaginationInfo(): void {
    if (this.dtIntiFlag === true) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const pgsInfo = dtInstance.page.info();
        this.dtCurrentpage = pgsInfo.page;
        this.dtCurrentLen = pgsInfo.length;
     });
    }
  }
  loadHighCharts1Options() {
    this.chart1Options = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      xAxis: {
        min: 0,
        title: {
          text: null
        },
        categories: this.chartData.categories,
        // labels: {
        //   formatter: () => {
        //     this.i++;
        //     return this.chartData[this.i].name;
        //   }
        // },
        lineWidth: 2
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        labels: {
          formatter: function () {
            return Math.round(this.value);
          }
        },
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Math.round(this.y) ;
            },
          },
        },
      },
      series: [{
        data: this.chartData.series,
        type: 'column'
      }]
    };
  }

  loadHighCharts2Options() {
    this.chart2Options = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      colors: ['#f16e00'],
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          rotation: -45,
        },
        categories: this.chartData2.categories,
        lineWidth: 2,
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        labels: {
          formatter: function () {
            return Math.round(this.value);
          }
        },
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Math.round(this.y);
            }
          },
        },
      },
      series: [
        {
          name: '',
          data: this.chartData2.series,
          // type: 'column'
        }
      ]
    };
  }

  onFilter() {
    this.chartData = {
      categories: [],
      series: []
    };
    this.chartData2 = {
      categories: [],
      series: []
    };
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    const params = new HttpParams({
      fromObject: {
        schoolId: this.staticFilter.schoolId,
        dateInterval: JSON.stringify([
          moment(this.filter.dateInterval[0]).format('YYYY-MM-DD'),
          moment(this.filter.dateInterval[1]).format('YYYY-MM-DD')
        ])
      }
    });
    this.http.get(
      '/api/passengerSubscription/subscriptionInfo',
      { params }
    ).subscribe((data: any) => {
      // Distribution per Bus
      data.busesSubscriptionsCount.forEach((elt, idx) => {
        this.chartData.categories.push(elt['Bus.name']);
        this.chartData.series.push(parseInt(elt['passengersCount'])); // parseInt: convert to init before push
        // console.log('Info :  ' + elt['Bus.name'] + ' ' + parseInt(elt['passengersCount']));
      });

      // Distribution per days
      this.chartData2.categories  = data.days;
      this.chartData2.series = data.periodConnection;
  
      
      this.loadHighCharts1Options();
      this.loadHighCharts2Options();
      this.TotalsubScription = data.TotalsubScriptionPassengers;

      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
     });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard-essentiel/dashboard-essentiel.component.ts